/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommercialEditItemDto = {
  /**
   * Existing sales order item ID
   */
  id: number;
  /**
   * Markup type applied before discount
   */
  markupType: CommercialEditItemDto.markupType;
  /**
   * Markup value
   */
  markupValue: number;
  /**
   * Price after markup and before discount
   */
  adjustedPrice: number;
  /**
   * Discount type
   */
  discountType: CommercialEditItemDto.discountType;
  /**
   * Discount value
   */
  discountValue: number;
  /**
   * Final line price after markup and discount
   */
  finalPrice: number;
};
export namespace CommercialEditItemDto {
  /**
   * Markup type applied before discount
   */
  export enum markupType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
  /**
   * Discount type
   */
  export enum discountType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
}
